import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash/noop';
import themeable from 'zignal-landscape/lib/themeable';

/**
 * It allows you to display a single language element.
 *
 * @storybook Components-Languages--Language
 */
const Language = ({
  styles,
  className = '',
  name = 'Language',
  label = 'ABC',
  isSelected = false,
  onClickCallback = noop
}) => {
  const [selected, setSelected] = useState(isSelected);

  /* v8 ignore next */
  const onClickHandler = (e) => {
    e.preventDefault();
    setSelected(!selected);
    setImmediate(() => onClickCallback(!selected));
  };

  return (
    <div
      className={classNames(selected ? styles.L_ContainerSelected : styles.L_Container, className)}
      onClick={onClickHandler}
    >
      <span className={selected ? styles.L_OvalSelected : styles.L_Oval} />
      <span className={styles.L_Name}>{name}</span>
      <span className={styles.L_Label}>/{label}</span>
    </div>
  );
};

Language.propTypes = {
  styles: PropTypes.object.isRequired,
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  isSelected: PropTypes.bool,
  onClickCallback: PropTypes.func
};

export default themeable(Language);
